export default __webpack_public_path__ + "static/airplane-window-featured-0821a9aeb4f566d3c044744f091fa442.jpg";